import { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon, IconButton, If } from '@fashionnovateam/nova-ui-toolkit';
import VPLogo from '../../Assets/images/vp-logo.png';
import FNLogo from '../../Assets/images/fn-logo.png';
import { NavigationProps } from './Props';
import { NavigationMobilePopup } from './NavigationMobilePopup';
import { isExternalUser } from './utils';
import { NavigationProvider } from '../../Lib/Hooks/navigation';
import { useCurrentUser } from '../../Lib/Contexts/CurrentUserContext';
import Roles from '../../Lib/Constants/roles';
// TODO: [HALO-MIGRATION] Remove HaloMigrationBanner import after migration is complete
import HaloMigrationBanner from '../HaloMigrationBanner/HaloMigrationBanner';
// TODO: [HALO-MIGRATION] Remove HaloMigrationMobileModal import after migration is complete
import HaloMigrationMobileModal from '../HaloMigrationBanner/HaloMigrationMobileModal';

export function NavigationMobile(props: NavigationProps) {
  const { children, ...otherProps } = props;
  const [isOpen, setIsOpen] = useState(false);
  const toggleOpen = useCallback(() => setIsOpen((prev) => !prev), []);
  const isExternal =
    (props.user && isExternalUser(props.user)) ||
    (props.currentUser && isExternalUser(props.currentUser));
  const { currentUser } = useCurrentUser();

  // TODO: [HALO-MIGRATION] Remove migration logic after migration is complete
  const migrationType = currentUser?.migrated_to_halo;
  const isMigrated =
    currentUser?.role === Roles.INFLUENCER &&
    (migrationType === 'influencer' || migrationType === 'agency');

  return (
    <NavigationProvider>
      {/* TODO: [HALO-MIGRATION] Remove HaloMigrationMobileModal after migration is complete */}
      {isMigrated && migrationType && (
        <HaloMigrationMobileModal migrationType={migrationType} />
      )}
      <div className="h-full flex flex-col overflow-hidden">
        {/* TODO: [HALO-MIGRATION] Remove HaloMigrationBanner after migration is complete */}
        {isMigrated && migrationType && <HaloMigrationBanner />}
        <div className="twp bg-neutral-100 border-b border-neutral-300 w-screen">
          <div className="px-5 py-2 flex justify-between">
            <Link to="/">
              <img
                className="flex-initial w-8 h-8 rounded-lg"
                alt="logo"
                src={isExternal ? FNLogo : VPLogo}
              />
            </Link>
            <IconButton
              className="flex-initial"
              label="Open navigation"
              icon={<Icon name="burger menu/burger-menu-two" />}
              color="secondary"
              onClick={toggleOpen}
            />
            <If condition={isOpen}>
              <NavigationMobilePopup onClose={toggleOpen} {...otherProps} />
            </If>
          </div>
        </div>
        <div className="overflow-auto h-full w-full">{children}</div>
      </div>
    </NavigationProvider>
  );
}
